module.exports = __webpack_public_path__ + "media/images/covers/Tamara-Consultations-Banner-0080834cc5aad57714cc5f89efe8d29d.jpg";